import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import './nav.css';
import { useNavigate } from 'react-router-dom';
import { useSetAtom, useAtomValue } from "jotai";
import {
  sheetData,
  airesponse,
  length,
  selectdata,
  insertDirectionAtom,
  rowIndexAtom,
  colIndexAtom,
  aiResponseColumnsAtom,tableNameAtom ,keywordAtom
} from "../../Atoms"; // Import the atom

const TableHeader = () => {
  const setKeyword=useSetAtom(keywordAtom)
  const [isEditing, setIsEditing] = useState(false); // Track whether we're in editing mode
  const setTableName = useSetAtom(tableNameAtom); // Function to update table name globally
  const tableName = useAtomValue(tableNameAtom); // Get the current table name value from the atom
  const navigate = useNavigate();

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem('user'); // Clear user credentials
    navigate('/');
  };

  // Handle input change and update the atom
  const handleTableNameChange = (e) => {
    setTableName(e.target.value); // Update the table name in Jotai's global state
  };

  // Toggle between editing and displaying the table name
  const handleEditClick = () => {
    setIsEditing(true);
  };

  // Save the table name when "Enter" is pressed
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      setIsEditing(false); // Exit edit mode
    }
  };

  return (
    <div className="table-header">
      <div className="left-section">
        {!isEditing? (
          <input
            type="text"
            value={tableName}
            onChange={handleTableNameChange}
            onKeyPress={handleKeyPress} 
            onBlur={() => setIsEditing(false)} 
            autoFocus 
            className="table-name-input"
          />
        ) : (
         
          <h1 className="table-name" onClick={handleEditClick}>
            {tableName} 
          </h1>
        )}
      </div>
      <div className="right-section">
        <button className="add-button" onClick={handleLogout}>
          <FontAwesomeIcon icon={faSignOutAlt} /> Logout
        </button>
      </div>
    </div>
  );
};

export default TableHeader;
